<template functional>
  <div>
    <div class="modal-header d-sm-block d-none" slot="header">
      <h1>{{ props.modalName }}</h1>
    </div>
    <div class="d-sm-none">
      <b-button size="sm" @click="listeners.cancel" class="float-right">
        <b-icon-x font-scale="2"/>
      </b-button>
      <h4>{{ props.modalName }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VModalHeader',
  props: {
    modalName: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped></style>
